import React from "react";
import LandingPage from "./pages/LandingPage";

export default function App() {
  return (
    <div className="h-full font-sans">
      <LandingPage />
    </div>
  );
}
